import request from "@/utils/request.ts";

export function deviceList(data: any) {
  return request({
    url: "/project/mobile/deviceManage/page",
    method: "post",
    data: data,
  });
}
